import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { getInfoGraphicsData } from 'features/views/dashboard/statistics/selectors';
import { equalOrThreeDashes } from 'utils/equalOrThreeDashes';
import { currency } from 'utils/formats';

export const ProductionsInfo = () => {
	const { production = {} } = useSelector(getInfoGraphicsData);

	const productionGraphShrinkedInFirstRow = useMediaQuery((theme) => theme.breakpoints.up('xl'));

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.productionSummary} forceInlineError>
			<Paper
				sx={{
					backgroundColor: (theme) => theme.palette.background[100],
					borderRadius: 1,
					height: productionGraphShrinkedInFirstRow ? '198px' : '80px',
					p: 3,
				}}
			>
				<Grid
					container
					sx={{
						height: '100%',
						alignItems: 'center',
					}}
				>
					<Grid size={12}>
						<Grid
							container
							spacing={productionGraphShrinkedInFirstRow ? 1 : 3}
							sx={{
								justifyContent: 'center',
							}}
						>
							<Grid
								size={{
									xs: 6,
									xl: 12,
								}}
							>
								<Stack
									direction="row"
									sx={{
										justifyContent: 'space-between',
										flexWrap: 'wrap',
									}}
								>
									<Typography variant="body1">
										{getMessage('dashboard:statistics.campaignsProduction')}
									</Typography>
									<Typography
										variant="body1"
										align="right"
										sx={{
											fontWeight: 'bold',
										}}
									>
										{production?.productionAmount
											? currency(production?.productionAmount)
											: equalOrThreeDashes()}
									</Typography>
								</Stack>
							</Grid>
							<Grid
								size={{
									xs: 6,
									xl: 12,
								}}
							>
								<Stack
									direction="row"
									sx={{
										justifyContent: 'space-between',
										flexWrap: 'wrap',
									}}
								>
									<Typography variant="body1">
										{getMessage('dashboard:statistics.newPoliciesCount')}
									</Typography>
									<Typography
										variant="body1"
										sx={{
											fontWeight: 'bold',
										}}
									>
										{!production?.productionPsCount
											? equalOrThreeDashes()
											: production?.productionPsCount}
									</Typography>
								</Stack>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Paper>
		</ComponentLoader>
	);
};

export default ProductionsInfo;
